import { render, staticRenderFns } from "./FallingPetals.vue?vue&type=template&id=2a7b3f45"
import script from "./FallingPetals.vue?vue&type=script&lang=js"
export * from "./FallingPetals.vue?vue&type=script&lang=js"
import style0 from "./FallingPetals.vue?vue&type=style&index=0&id=2a7b3f45&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports